import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert, Box, Button, Card, CardContent, CircularProgress, TextField, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { aktivieren } from '../api';
import { HINTERGRUND_OEFFENTLICH, Kopieren, Markenkopf } from '../komponenten/Bausteine';
import { fehlertext } from '../utils/format';

export default function Aktivierung() {
  const [params] = useSearchParams();
  const [form, setForm] = useState({ name: params.get('kunde') || '', code: '', hardware_id: params.get('hardware_id') || '' });
  const [fehler, setFehler] = useState('');
  const [laedt, setLaedt] = useState(false);
  const [key, setKey] = useState('');

  const absenden = async (e) => {
    e.preventDefault();
    setLaedt(true);
    setFehler('');
    try {
      const r = await aktivieren(form);
      setKey(r.data.lizenz_key);
    } catch (err) {
      setFehler(fehlertext(err, 'Aktivierung fehlgeschlagen.'));
    } finally {
      setLaedt(false);
    }
  };

  return (
    <Box sx={HINTERGRUND_OEFFENTLICH}>
      <Card sx={{ width: '100%', maxWidth: 480, p: 1 }}>
        <CardContent sx={{ p: 3 }}>
          <Markenkopf
            titel="ProfiWare aktivieren"
            text={key ? '' : 'Name und Aktivierungscode haben Sie von uns erhalten. Die Hardware-ID zeigt ProfiWare im Installer und unter Einstellungen → Lizenz.'}
          />
          {fehler && <Alert severity="error" sx={{ mb: 2 }}>{fehler}</Alert>}

          {key ? (
            <Box sx={{ textAlign: 'center' }}>
              <CheckCircleIcon sx={{ fontSize: 48, color: 'success.main', mb: 1 }} />
              <Typography sx={{ fontWeight: 600, mb: 0.5 }}>Aktivierung erfolgreich</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Diesen Lizenzschlüssel in ProfiWare unter Einstellungen → Lizenz einfügen:
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, p: 1.5, borderRadius: 2, bgcolor: 'action.hover', textAlign: 'left' }}>
                <Box sx={{ flex: 1, wordBreak: 'break-all', fontFamily: 'ui-monospace, Consolas, monospace', fontSize: '0.78rem', userSelect: 'all' }}>{key}</Box>
                <Kopieren text={key} titel="Schlüssel kopieren" />
              </Box>
            </Box>
          ) : (
            <Box component="form" onSubmit={absenden} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                id="aktivierung-name" label="Name (wie von uns mitgeteilt)" value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })} required fullWidth autoFocus
                helperText="Groß- und Kleinschreibung spielt keine Rolle."
              />
              <TextField
                id="aktivierung-code" label="Aktivierungscode" value={form.code}
                onChange={(e) => setForm({ ...form, code: e.target.value })} required fullWidth placeholder="1234-5678-9012-3456-7890-1234"
              />
              <TextField
                id="aktivierung-hardware" label="Hardware-ID" value={form.hardware_id}
                onChange={(e) => setForm({ ...form, hardware_id: e.target.value })} required fullWidth placeholder="AB12-CD34-EF56-7890-1234-5678"
              />
              <Button type="submit" variant="contained" fullWidth disabled={laedt} sx={{ mt: 0.5, py: 1.2 }}>
                {laedt ? <CircularProgress size={22} sx={{ color: '#1A1A1A' }} /> : 'Aktivieren'}
              </Button>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
